import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {observer} from 'mobx-react';

function NotesSearchResultsListItem({
                                      avatarIcon,
                                      linkToNote,
                                      note,
                                      linkShareInfo,
                                      text,
                                    }) {
  const style = styles();

  const listItem = () => {
    return (
      <ListItem alignItems="flex-start">
        {avatarIcon}
        <ListItemText
          primary={
            <Box sx={style.headerContainer}>
              <Typography
                variant="body1"
                color="text.primary"
                style={{zIndex: 2}}>
                {note.title}
              </Typography>
            </Box>
          }
          secondary={
            <Box sx={style.subtitleContainer}>
              <Box sx={style.rowContainer}>
                <Typography sx={style.markdownText}>
                  {text}
                </Typography>
              </Box>
            </Box>
          }
        />
      </ListItem>
    );
  };

  if (note.isFile && !note.isAnImage) {
    return <a
      style={style.link}
      href={note.publicUrl}
      target="_blank"
      rel={'noreferrer'}>
      {listItem()}
    </a>;
  }

  return (
    <Link style={style.link} to={linkToNote}
          state={linkShareInfo}>
      {listItem()}
    </Link>
  );
}

export default observer(NotesSearchResultsListItem);

const styles = () => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '10px'
  },
  rowContainer: {
    display: 'flex',
    gap: '5px'
  },
  markdownText: {
    display: '-webkit-box',
    overflow: 'hidden',
    fontSize: '0.9rem',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
  },
  titleInput: {
    background: 'none',
    border: 'none',
    fontSize: '1rem'
  },
  subtitleContainer: {
    display: 'flex',
    gap: '8px',
    flexDirection: 'column'
  },
  subtitleDate: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  link: {
    display: 'flex',
    marginRight: '10px',
    textDecoration: 'none'
  }
});